var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2daae1;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-126.443 -2.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(126.443 2.281)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M252.315,145.265a8.273,8.273,0,0,1-2.38.653,4.156,4.156,0,0,0,1.822-2.292,8.279,8.279,0,0,1-2.632,1.006,4.146,4.146,0,0,0-7.168,2.836,4.192,4.192,0,0,0,.107.945,11.766,11.766,0,0,1-8.541-4.329,4.148,4.148,0,0,0,1.282,5.532,4.125,4.125,0,0,1-1.877-.518v.052a4.146,4.146,0,0,0,3.324,4.063,4.123,4.123,0,0,1-1.092.145,4.2,4.2,0,0,1-.78-.073,4.149,4.149,0,0,0,3.87,2.878,8.344,8.344,0,0,1-6.135,1.715,11.784,11.784,0,0,0,18.142-9.927q0-.27-.013-.536A8.444,8.444,0,0,0,252.315,145.265Z",
    transform: "translate(-100.019 -133.498)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter3);
export default __webpack_public_path__ + "static/media/twitter-3.1f597650dab249bd704b06b9a9708d63.svg";
export { ForwardRef as ReactComponent };